import { useEffect, useState, useMemo } from 'react'
import { useGetIcons } from '../../hooks/useIconMaster'

interface IconItem {
    id: number
    name: string
    icon: string
    status: boolean
}

interface IconDropdownProps {
    value?: number | string | null
    onChange: (icon: IconItem | null) => void
    placeholder?: string
    disabled?: boolean
}

const IconDropdown = ({
    value,
    onChange,
    placeholder = 'Select Icon',
    disabled = false,
}: IconDropdownProps) => {
    // const { data: iconsResponse, isLoading } = useGetIcons()

    const [open, setOpen] = useState(false)
    const [selectedIcon, setSelectedIcon] = useState<IconItem | null>(null)
    const [search, setSearch] = useState('')


    const { data: iconsResponse, isLoading } = useGetIcons(
        search ? { search } : {}
    )
    const icons: IconItem[] =
        Array.isArray(iconsResponse?.data?.results)
            ? iconsResponse.data.results.filter((icon: IconItem) => icon.status)
            : []

    useEffect(() => {
        if (value && icons.length) {
            const found = icons.find((icon) => icon.id === value || icon.icon === value)
            setSelectedIcon(found || null)
        }
    }, [value, icons])

    const handleSelect = (icon: IconItem) => {
        setSelectedIcon(icon)
        onChange(icon)
        setOpen(false)
        setSearch('') // clear search after select
    }

    // const filteredIcons = useMemo(() => {
    //     if (!search) return icons
    //     return icons.filter((icon) =>
    //         icon.name.toLowerCase().includes(search.toLowerCase())
    //     )
    // }, [icons, search])

    const filteredIcons = icons

    const toggleDropdown = () => {
        if (disabled) return
        setOpen((prev) => {
            if (prev) setSearch('') // clear search when closing
            return !prev
        })
    }

    return (
        <div className="relative w-full">
            {/* Selected value */}
            <div
                className={`flex items-center justify-between border rounded px-3 py-2 cursor-pointer ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                    }`}
                onClick={toggleDropdown}
            >
                {selectedIcon ? (
                    <div className="flex items-center gap-2 dark:text-white">
                        <img
                            src={selectedIcon.icon}
                            alt={selectedIcon.name}
                            width={18}
                            height={18}
                        />
                        <span>{selectedIcon.name}</span>
                    </div>
                ) : (
                    <span className="text-gray-400">{placeholder}</span>
                )}

                <span className="text-xs dark:text-white">▼</span>
            </div>

            {/* Dropdown list */}
            {open && (
                <div className="absolute z-50 mt-1 w-full border rounded bg-white shadow">
                    {/* Search input */}
                    <div className="p-2 border-b">
                        <input
                            type="text"
                            placeholder="Search icon..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full px-2 py-1 border rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                    </div>

                    <div className="max-h-[7rem] overflow-auto">
                        {isLoading && (
                            <div className="p-2 text-sm text-gray-500">
                                Loading...
                            </div>
                        )}

                        {!isLoading && filteredIcons.length === 0 && (
                            <div className="p-2 text-sm text-gray-500">
                                No icons found
                            </div>
                        )}

                        {filteredIcons.map((icon) => (
                            <div
                                key={icon.id}
                                className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                onClick={() => handleSelect(icon)}
                            >
                                <img
                                    src={icon.icon}
                                    alt={icon.name}
                                    width={18}
                                    height={18}
                                />
                                <span>{icon.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default IconDropdown